import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts'
import { getDashboardKnowFromWhereGraph, getDashboardLeadGraph } from '../../../appRedux/actions';
import FilterBarChartMonthlyRegister from '../../../components/adminRole/dashboard/FilterBarChartMonthlyRegister';
import moment from 'moment';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8D0B41', '#D39D55', '#5DB996', '#118B50', '#FF8383', '#FFF574', '#A1D6CB', '#A19AD3'];

export default function PieChartLead({ trainingOptions, locations }) {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    training_option_id: null,
    status: null,
    is_retraining: null,
    start_date: moment().startOf('year').toISOString(),
    end_date: moment().endOf('year').toISOString(),
    location: null,
    category_id: null,
  })

  useEffect(() => {
    getDashboardLeadGraph(filter).then((rows) => {
      setData(rows)
    });
  }, [filter])

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    return (percent * 100).toFixed(2) + "%" + " | " + data[index].value
  };

  const changeFilterTraining = (training_option_id) => {
    setFilter({ ...filter, training_option_id })
  }

  const changeFilterStatus = (status) => {
    setFilter({ ...filter, status })
  }

  function handleChangeFilter(filter) {
    setFilter(filter)
  }

  return (
    <>
      <FilterBarChartMonthlyRegister
        valueFilterTraining={filter.training_option_id}
        onChangeFilterTraining={changeFilterTraining}
        trainingOptions={trainingOptions}
        valueFilterStatus={filter.status}
        onChangeFilterStatus={changeFilterStatus}
        locations={locations}
        filter={filter}
        setFilter={handleChangeFilter}
        picker='day'
      />
      <ResponsiveContainer width="100%" height={250}>
        <PieChart width={600} height={600}>
          <Tooltip />
          <Legend />
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#8884d8"
            dataKey={"value"}
            nameKey={"name"}
            label={renderCustomizedLabel}
            // label={true}
            labelLine={true}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}>
                {index}
              </Cell>
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <center><h4 style={{ color: COLORS[0] }}>Sumber Leads</h4></center>
    </>
  )
}
